// Handles async requests with a monotonically increasing clock, to prevent earlier requests overwriting
// later ones when responses arrive out of order
export default class ClockedRequest {
	constructor() {
		this.state = {
			fetchFn: function() {},
			pathParams: {},
			queryParams: URLSearchParams,
			requestClock: 0,
			responseClock: 0,
			data: {},
			isFetching: false,
		};
	}

	setFetchFn = (fn) => {
		this.state.fetchFn = fn;
	};
	setPathParams = (params) => {
		this.state.pathParams = params;
	};
	setQueryParams = (params) => {
		this.state.queryParams = params;
	};

	isFetching = () => this.state.isFetching;

	// Returns response data when this request is still the latest; otherwise null so callers
	// can ignore stale completions (BEZ-5831).
	fetch = async () => {
		this.state.requestClock++;
		this.state.isFetching = true;
		const thisRequestClock = this.state.requestClock;

		const res = await this.state.fetchFn(
			this.state.pathParams,
			this.state.queryParams,
		);

		if (thisRequestClock > this.state.responseClock) {
			this.state.responseClock = thisRequestClock;
			this.state.data = res?.data;
			this.state.isFetching = false;
			return this.state.data;
		}

		this.state.isFetching = false;
		return null;
	};
}
